const VariedPermissionsSection = () => (
  <p className="warning-section">
    <strong>The users you selected have varying permissions</strong> so bulk deletion has been disabled. Select 2 or more users with the same permissions to perform this operation in bulk.
  </p>
)

export default VariedPermissionsSection


// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/TeamTable/VariedPermissionsSection.js